/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import Svg from 'rp-react-svg-icon';

/**
 * Component that is used for rendering <CardsError />
 * It tells that some problem occurs during to retrieving races
 */
const CardsError = () => (
    <div className="rh-cards__errorsHandle ui-errorMessage">
        <Svg isInlined iconName="results" selector="img-errorMessageImage" />
        <div className="ui-errorMessage__container" data-test-selector="text-errorMessageText">
            <span className="ui-errorMessage__text">
                Data currently unavailable, please try again later.
            </span>
        </div>
    </div>
);

export { CardsError as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CardsError/CardsError.js